import { CommonModule } from '@angular/common'
import { Component, Inject } from '@angular/core'
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms'
import { MatButtonModule } from '@angular/material/button'
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'

@Component({
  selector: 'ngx-send-test-email-dialog',
  template: `
    <h2 mat-dialog-title>Send test email</h2>
    <mat-dialog-content>
      <form [formGroup]="form" (ngSubmit)="submit()">
        <mat-form-field class="w-100">
          <input matInput placeholder="Email address" formControlName="email" />
        </mat-form-field>
        <mat-form-field class="w-100">
          <input matInput placeholder="Subject" formControlName="subject" />
        </mat-form-field>
      </form>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-raised-button color="warn" (click)="close()">Cancel</button>
      <button mat-raised-button color="primary" [disabled]="form.invalid" (click)="submit()">Send</button>
    </mat-dialog-actions>
  `,
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatDialogModule, MatFormFieldModule, MatInputModule, MatButtonModule]
})
export class SendTestEmailDialogComponent {
  form: UntypedFormGroup
  constructor(
    private fb: UntypedFormBuilder,
    private dialogRef: MatDialogRef<SendTestEmailDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { email: string; subject: string }
  ) {
    this.form = this.fb.group({
      email: [data?.email || '', [Validators.required, Validators.email]],
      subject: [data?.subject || '', [Validators.required, Validators.minLength(2)]]
    })
  }

  close() {
    this.dialogRef.close()
  }

  submit() {
    if (this.form.valid) {
      this.dialogRef.close(this.form.value)
    }
  }
}
